import React from "react";

function Xicon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 18 18" fill="currentColor" {...props}>
      <path
        d="M12.45 3.5625H14.2905L10.2705 8.169L15 14.4375H11.2972L8.397 10.635L5.07825 14.4375H3.237L7.53675 9.51L3 3.5625H6.79725L9.4185 7.03725L12.45 3.5625ZM11.805 13.3335H12.825L6.24225 4.60875H5.14875L11.805 13.3335Z"
        fill="black"
      />
    </svg>
  );
}

const MemoXicon = React.memo(Xicon);
export default MemoXicon;
